var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dev-config" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "开发配置",
            visible: _vm.dialogFormVisible,
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户号：" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.customerNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "customerNumber", $$v)
                      },
                      expression: "form.customerNumber",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "客户名称：" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.customerName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "customerName", $$v)
                      },
                      expression: "form.customerName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "签名Key：" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.signatureKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "signatureKey", $$v)
                      },
                      expression: "form.signatureKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "超时时间：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.timeout,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "timeout", $$v)
                      },
                      expression: "form.timeout",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v("商户端超时时间，单位分钟"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "回调域名：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.callbackDomain,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "callbackDomain", $$v)
                      },
                      expression: "form.callbackDomain",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v(
                      "充值结果异步通知商户地址，非必填、 没有填写则不进行回调"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "IP白名单：" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.ipWhitelist,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "ipWhitelist", $$v)
                      },
                      expression: "form.ipWhitelist",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v("每行填写一个ip，0.0.0.0为允许所有IP"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }